import { render, staticRenderFns } from "./DeleteInner.vue?vue&type=template&id=306a5b64&scoped=true&"
import script from "./DeleteInner.vue?vue&type=script&lang=js&"
export * from "./DeleteInner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306a5b64",
  null
  
)

export default component.exports